<app-page-header [heading]="'Pricing Plan'" [icon]="'fa-rupee'" style="height:100px;"></app-page-header>
<div class="page-panel">

  <div class=" col-lg-12 text-right">
    <button (click)="open(slabA)" class="btn-sm btn btn-danger">&nbsp;<span
      style="color: white;font-size: 15px;font-weight: bold;">A</span>&nbsp;
    </button>&nbsp;&nbsp;
    <button (click)="open(slabB)" class="btn-sm btn btn-danger">&nbsp;<span
      style="color: white;font-size: 15px;font-weight: bold;">B</span>&nbsp;
    </button>&nbsp;&nbsp;
    <button (click)="open(slabC)" class="btn-sm btn btn-danger">&nbsp;<span
      style="color: white;font-size: 15px;font-weight: bold;">C</span>&nbsp;
    </button>&nbsp;&nbsp;
    <button (click)="open(all)" class="btn-sm btn btn-danger"><span
      style="color: white;font-size: 15px;font-weight: bold;">All</span></button>
  </div>
  <div *ngIf="user_rights.ADD == '1'">
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-lg-6">
        <label>Purchase Number</label>
        <ngx-select-dropdown (change)="getInvoice();listPurchaseItems();"
                             [(ngModel)]="invoice_data"
                             [config]="utils.dropConfig({displayKey: 'INVOICE',placeholder: 'Select Purchase Details',searchOnKey: 'INVOICE'})"
                             [multiple]="false"
                             [options]="invoice_options" class="form-control  select-dropdown"
                             name="sel_tpa_receiver"></ngx-select-dropdown>
      </div>
      <div class=" col-lg-6">
        <label>Particular Name</label>
        <div class="input-group ">
          <input (keydown)="keyDownFunction($event)" [(ngModel)]="pricing_plan.search_text" class="form-control"
                 id="typeahead-http"
                 name="search_text" placeholder="Search Particular Name...." type="text">
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="pricing_plan.purchase_details_id.length > 0" class="">
      <table class="table tbl table-striped table-bordered">
        <thead>
        <tr class="text-center">
          <th rowspan="2" width="1%">#</th>
          <th rowspan="2">Item</th>
          <th rowspan="2" width="6%">Base Rate</th>
          <th rowspan="2" width="6%">Freight Charge</th>
          <th rowspan="2" width="6%">Rate</th>
          <th rowspan="2" width="6%">Flood cess rate</th>
          <th colspan="2">Slab A</th>
          <th colspan="2">Slab B</th>
          <th colspan="2">Slab C</th>
          <th colspan="2">Web</th>
          <th rowspan="2" width="6%">MRP</th>

        </tr>
        <tr class="text-center">
          <th width="7%">%</th>
          <th width="7%">Amount</th>
          <th width="7%">%</th>
          <th width="7%">Amount</th>
          <th width="7%">%</th>
          <th width="7%">Amount</th>
          <th width="7%">%</th>
          <th width="7%">Amount</th>
        </tr>
        <tr *ngIf="(item_list | json) == '[]'">
          <td class="text-center" colspan="15">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of item_list;let i=index" style="font-size: 12px">
          <td>{{ i + 1 }}</td>
          <td>{{ data.TRADE_NAME }}</td>
          <td class="text-right">{{ data.UNIT_PRICE }}</td>
          <td class="text-right">{{ data.ONE_ITEM_FREIGHT_CHARGE }}</td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.unitprice[i]"
                     class="form-control " maxlength="10"
                     name="rate" type="text"></td>
          <td class="text-right"><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.flood[i]"
                                        [readOnly]="true" class="form-control "
                                        maxlength="10" name="flood"
                                        type="text"></td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.slab_a_per[i]"
                     class="form-control " maxlength="10"
                     name="slab_a_per" type="text"></td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.slab_a_amount[i]" [readOnly]="true"
                     class="form-control text-right " maxlength="10"
                     name="slab_a_amount" tabIndex="-1"
                     type="text"></td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.slab_b_per[i]"
                     class="form-control " maxlength="10"
                     name="slab_b_per" type="text"></td>
          <td><input [(ngModel)]="pricing_plan.slab_b_amount[i]" [readOnly]="true"
                     class="form-control text-right " maxlength="10" name="slab_b_amount"
                     tabIndex="-1" type="text">
          </td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.slab_c_per[i]"
                     class="form-control " maxlength="10"
                     name="slab_c_per" type="text"></td>
          <td><input [(ngModel)]="pricing_plan.slab_c_amount[i]" [readOnly]="true"
                     class="form-control text-right " maxlength="10" name="slab_c_amount"
                     tabIndex="-1" type="text">
          </td>
          <td><input (focusout)="calculateSlabRates()" [(ngModel)]="pricing_plan.web_per[i]"
                     class="form-control " maxlength="10"
                     name="web_per" type="text"></td>
          <td><input [(ngModel)]="pricing_plan.web_amount[i]" [readOnly]="true"
                     class="form-control text-right " maxlength="10" name="web_amount"
                     tabIndex="-1" type="text"></td>
          <td class="text-right">{{ data.MRP }}</td>


        </tr>
        </tbody>
      </table>
      <div class="clearfix"></div>
      <div class="row container">
        <div class="col-lg-7 pull-right">
          <button (click)="saveSlabDetails();" *ngIf="user_rights.ADD == '1'"
                  class="btn btn-info btn-sm ng-star-inserted"
                  type="button">&nbsp;Save&nbsp;
          </button>&nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>

  </div>
</div>
<ng-template #slabA>
  <div class="modal-body">
    <label>
      <b>Discounted Sales</b>
      <br><br>
      <ng-container *ngFor="let item of discount_list;">
        {{ item.TRADE_NAME }}&nbsp;MRP Rs.{{ round(item.MRP) }}/- is now available at Rs.{{ round(item.SLAB_A_AMOUNT) }}
        /- only.
        <br><br>
      </ng-container>
      Home delivery in Trivandrum.
      <br><br>
      Contact :&nbsp; +91 96050 33 666 , +91 96050 22 666
    </label>
  </div>
</ng-template>
<ng-template #slabB>
  <div class="modal-body">
    <label>
      <b>Discounted Sales</b>
      <br><br>
      <ng-container *ngFor="let item of discount_list;">
        {{ item.TRADE_NAME }}&nbsp;MRP Rs.{{ round(item.MRP) }}/- is now available at Rs.{{ round(item.SLAB_B_AMOUNT) }}
        /- only.
        <br><br>
      </ng-container>
      Home delivery in Trivandrum.
      <br><br>
      Contact :&nbsp; +91 96050 33 666 , +91 96050 22 666
    </label>
  </div>
</ng-template>
<ng-template #slabC>
  <div class="modal-body">
    <label>
      <b>Discounted Sales</b>
      <br>
      <br>
      <ng-container *ngFor="let item of discount_list;">
        {{ item.TRADE_NAME }}&nbsp;MRP Rs.{{ round(item.MRP) }}/- is now available at Rs.{{ round(item.SLAB_C_AMOUNT) }}
        /- only.
        <br><br>
      </ng-container>
      Home delivery in Trivandrum.
      <br><br>
      Contact :&nbsp; +91 96050 33 666 , +91 96050 22 666
    </label>
  </div>
</ng-template>
<ng-template #all>
  <div class="modal-body">
    <label>
      <b>Discounted Sales</b>
      <br><br>
      <ng-container *ngFor="let item of discount_list;">
        {{ item.TRADE_NAME }}&nbsp;
        MRP Rs.{{ round(item.MRP) }}/-,&nbsp;
        <b>Rs.{{ round(item.SLAB_A_AMOUNT) }}/-,&nbsp;
          Rs.{{ round(item.SLAB_B_AMOUNT) }}/-,&nbsp;
          Rs.{{ round(item.SLAB_C_AMOUNT) }}/-</b>
        <br><br>
      </ng-container>
      Home delivery in Trivandrum.
      <br><br>
      Contact :&nbsp; +91 96050 33 666 , +91 96050 22 666
    </label>
  </div>
</ng-template>
